import { render, staticRenderFns } from "./ProdOrderBackflush.vue?vue&type=template&id=1a18ad9a&scoped=true&"
import script from "./ProdOrderBackflush.vue?vue&type=script&lang=js&"
export * from "./ProdOrderBackflush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18ad9a",
  null
  
)

export default component.exports